module.exports = __webpack_public_path__ + "static/media/peixe-boi-capa.91757200.png";